var React = require('react');

function LinkedInIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.5 15.583h-2.277V12.01c0-.852-.017-1.948-1.186-1.948-1.185 0-1.366.928-1.366 1.887v3.634H9.39V8.237h2.187v1.001h.031c.305-.576 1.049-1.186 2.158-1.186 2.307 0 2.733 1.521 2.733 3.501v4.03zM6.822 7.23A1.322 1.322 0 0 1 5.5 5.906a1.322 1.322 0 1 1 2.642 0c0 .731-.592 1.324-1.32 1.324zM5.68 15.583h2.28V8.237h-2.28v7.346z","fill":"#FFF","fillRule":"evenodd"}));
}

LinkedInIcon.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = LinkedInIcon;

LinkedInIcon.default = LinkedInIcon;
